// Dates and availability for the dated question bank. Pure and tiny on purpose:
// the homepage uses these, and must not pull the whole question bank in with them
// (that is what bank.ts, which reads the bank, is for). See bank.ts for the design.
// "As of" for the original bank, and for anything that doesn't say.
export const BASELINE_AS_OF = '2000-01-01';
const DATE = /^\d{4}-\d{2}-\d{2}$/;
export const isAsOf = (value) => typeof value === 'string' && DATE.test(value) && !Number.isNaN(Date.parse(value));
// Anything missing or malformed means the original bank, which every client has.
export const normalizeAsOf = (value) => (isAsOf(value) ? value : BASELINE_AS_OF);
// Today's date in UTC, the "as of" for games that start now.
export const todayAsOf = (now = new Date()) => now.toISOString().slice(0, 10);
export function availableAsOf(q, asOf) {
    return (q.addedOn ?? BASELINE_AS_OF) <= asOf && (!q.retiredOn || asOf < q.retiredOn);
}
// The multiple-choice questions among `questions` that a game dated asOf can draw from, in bank order
// (the order matters: a seeded shuffle starts from it).
export function poolAsOf(questions, asOf) {
    return questions.filter(q => q.type === 'multiple-choice' && availableAsOf(q, asOf));
}
